import { Injectable } from '@angular/core';
import { Access } from '../interfaces/access.interface';
import { AppHttpService } from './app-http.service';
import { Role } from '../models/role.model';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AccessService{
  allAccess: Access[] = [];
  userAccesses: number[] = [];
  user: User | undefined;

  constructor(private httpService: AppHttpService){}

  setAccess(accesses: Access[]) {
    this.allAccess = accesses;
  }

  setUserAccess(accessIds: number[]) {

    this.userAccesses = [...new Set(accessIds)];
    this.httpService.setUserAccess(this.userAccesses);
  }

  /**
   * Check User access
   * @param access
   * @returns
   */
  checkAccess(access: number | number[]) {
    const isArray = Array.isArray(access);
    if (isArray)
      return access.some((accessId) => this.userAccesses.includes(accessId));
    return this.userAccesses.includes(access);
  }
}
